import { AlertProvider } from "@gymflow/common";
import { useContext } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import Footer from "../components/Kiosk/Footer";
import { usePortalRoutes } from "../hooks/usePortalRoutes";
import { AbilityContext, Verb } from "../permissions";
import { ClubSettingsProvider, StaffPermissionsProvider } from "../providers";
import { AuthenticationProvider } from "../providers/authentication/AuthenticationProvider";
import { kiosk as routes } from "../routes";
import { RouteFeature } from "../routes/feature";
import { RouteLayout } from "../routes/layout";

function Kiosk({ match }: any) {
  const ability = useContext(AbilityContext);
  const { createClubLink } = usePortalRoutes();

  const defaultRoute = createClubLink(
    RouteLayout.Kiosk,
    RouteFeature.KioskCheckIn,
  );
  const getRoutes = () => {
    const nodes = routes.map((prop) => {
      const hasAccess =
        !prop.permission || ability.can(Verb.View, prop.permission);
      if (hasAccess) {
        return (
          <Route path={match.path + prop.path} key={prop.path}>
            {(props) => <prop.component {...props} />}
          </Route>
        );
      }
      return null;
    });
    nodes.push(
      <Route key={nodes.length}>
        <Redirect to={defaultRoute} />
      </Route>,
    );
    return nodes;
  };

  return (
    <div className="flex h-screen w-full flex-col">
      <div>
        <AlertProvider>
          <Switch>{getRoutes()}</Switch>
        </AlertProvider>
      </div>
      <Footer />
    </div>
  );
}

function KioskWithAuth({ ...props }) {
  return (
    <ClubSettingsProvider>
      <StaffPermissionsProvider>
        <Kiosk {...props} />
      </StaffPermissionsProvider>
    </ClubSettingsProvider>
  );
}

function KioskWithClub(props: any) {
  return (
    <AuthenticationProvider userType="staff">
      <KioskWithAuth {...props} />
    </AuthenticationProvider>
  );
}

export default KioskWithClub;
